export default function formatKeys() {
  return {
    dayRangeHeaderFormat: 'dayRangeHeaderFormat',
    eventTimeRangeFormat: 'eventTimeRangeFormat',
    eventTimeRangeStartFormat: 'eventTimeRangeStartFormat',
    eventTimeRangeEndFormat: 'eventTimeRangeEndFormat',
    agendaHeaderFormat: 'agendaHeaderFormat',
    agendaTimeRangeFormat: 'agendaTimeRangeFormat',
    dateFormat: 'dateFormat',
    dayFormat: 'dayFormat',
    weekdayFormat: 'weekdayFormat',
    agendaTimeFormat: 'agendaTimeFormat',
    timeGutterFormat: 'timeGutterFormat',
    monthHeaderFormat: 'monthHeaderFormat',
    dayHeaderFormat: 'dayHeaderFormat',
    agendaDateFormat: 'agendaDateFormat',
  };
}
